import { DialogClose, DialogContent, DialogFooter } from '@/components/atoms/Dialog';
import { Button } from '@/components/atoms/NewPcButton';
import { ROUTES } from '@/routes';
import { useNavigate } from 'react-router-dom';

export const UpdateAccountDialogContent = () => {
  const navigate = useNavigate();

  return (
    <DialogContent noCloseBtn className="w-fit gap-5 p-[30px]">
      <div className="space-y-1">
        <div className="text-gr-900 Title3S18">핸드폰 번호로 가입된 계정이에요</div>
        <div className="text-gr-700 Body5M14">
          비밀번호 설정을 위해 회원 정보 추가 입력이 필요해요
        </div>
      </div>
      <DialogFooter>
        <DialogClose asChild>
          <Button className="flex-1" variant="secondary">
            닫기
          </Button>
        </DialogClose>
        <Button className="flex-1" onClick={() => navigate(ROUTES.updateAccount)}>
          확인
        </Button>
      </DialogFooter>
    </DialogContent>
  );
};
